import type { ComponentClassNames } from '../../util/classNames';
import { getViewportUnitsFromDynamicValue } from '../../util/styles/getViewportUnitsFromDynamicValue';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';

import type { AppLayoutProps } from './AppLayout.types';

const dynamicHeightClassName = 'appLayout-dynamicHeight';

type GetClassNames = (
  height: AppLayoutProps['height'],
  disableNativePageScroll: boolean,
  backgroundColor?: AppLayoutProps['backgroundColor']
) => ComponentClassNames<'appLayout'>;
export const getClassNames: GetClassNames = memoizeFunction((height, disableNativePageScroll, backgroundColor) => {
  const viewportUnits = typeof height === 'string' ? getViewportUnitsFromDynamicValue(height) : undefined;

  const heightValue = viewportUnits !== undefined ? `${viewportUnits}vh` : height;
  const heightValueOverride = viewportUnits !== undefined ? height : undefined;

  return mergeStyleSets({
    appLayout: [
      {
        height: heightValue,
        [`&.${dynamicHeightClassName}`]: { height: heightValueOverride },
        backgroundColor,
      },
      {
        ':global(html)': disableNativePageScroll ? { height: '100%', overscrollBehavior: 'none' } : undefined,
        ':global(body)': disableNativePageScroll ? { height: '100%', overflow: 'hidden' } : undefined,
      },
      dynamicHeightClassName,
    ],
  });
});
